import type { Amount } from '@/domain/stripe/quote/model/Amount'

export class UnitAmountPresentation implements Amount {
  constructor(
    public readonly currency: string,
    public readonly amount: number,
    public readonly interval: string,
  ) {
  }
}
